<template>
  <div class="content-wrapper">
    <app-breadcrumb
        :page-title="pageTitle"
        :directory="$t('datatables')"
        :icon="'grid'"
    />
    <app-table :id="tableId" :options="options" @action="getListAction"/>
    <template v-if="addToScreeningModalShow">
      <app-modal
          :modal-id="modalId"
          modal-alignment="middle"
          modal-size="extra-large"
          :modal-scroll="false"
          @close-modal="closeModal"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t("Add To Screening") }}</h5>
          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
          </button>
        </template>
        <template slot="body">
          <div class="card card-with-search border-0 card-with-shadow">
            <div class="form-group row align-items-center ml-sm-2">
              <label class="col-sm-2 mb-sm-0">Select Screening Creation Date</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="date"
                         v-model="screening.created_at"
                         placeholder="Select Date"
                         popover-position="bottom-start"
              />
              <label class="col-sm-2 mb-sm-0">Select Screening Date</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="date"
                         v-model="screening.date"
                         placeholder="Select Date"
                         popover-position="bottom-start"
              />
              <!-- <label class="col-sm-2 mb-sm-0">Select Screening Time</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="time"
                         v-model="screening.time"
                         placeholder="Select Time"
              /> -->
              <label class="col-sm-2 mb-sm-0">Select Deployment Date</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="date"
                         v-model="screening.deployment_date"
                         placeholder="Select Deployment Date"
                         popover-position="bottom-start"
              />
              <label class="col-sm-2 mb-sm-0">Screening type</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="select"
                         :list="screeningTypeList"
                         v-model="screening.screening_type"
                         v-on:change="screeningTypeOnChange"
              />

              <label class="col-sm-2 mb-sm-0">Select Duration for history check</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="select"
                         v-model="screening.previous_history_duration"
                         placeholder="Select Duration for history check"
                         :list="screeningDuration"
              />
              <label class="col-sm-2 mb-sm-0">Available Credits ({{availableCredits}})</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="text"
                         v-model="screening.availCredit"
                         :read-only="true"
              />
              <el-button class="btn btn-secondary el-button--default col-sm-3"
                         @click.prevent="openLink()">
                Buy Screening Credits
              </el-button>
            </div>
          </div>
        </template>
        <template slot="footer">
          <button
              type="button"
              class="btn btn-success mr-2"
              @click.prevent="save">
            {{ $t("Start Screening") }}
          </button>
          <button
              type="button"
              class="btn btn-secondary mr-2"
              data-dismiss="modal"
              @click="closeModal">
            {{ $t("Cancel") }}
          </button>
        </template>
      </app-modal>
    </template>
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {TableHelpers} from "../../Demo/Tables/mixins/TableHelpers";
import {DELETE_APPLICATION, SHORT_LIST_CANDIDATES} from '../../../../Config/ScreeningAppUrl'
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {Candidate, Credits} from "@Views/Screening/utility/apiAgent";
import {screeningTypeList, screeningCreditsByType, screeningDuration} from "@Views/Screening/utility/constant";
import {screeningType} from "@Views/Screening/utility/enums/index";
import {mergeDateTime} from "@Views/Screening/utility/common/candidate";
import AppLibrary from "../../../../Helpers/AppLibrary";


export default {
  extends: AppLibrary,
  name: "ShortListCandidates",
  mixins: [TableHelpers, FormMixin, ModalMixin],
  props: {
    active: Number,
    customerCompany: {},
  },
  data() {
    return {
      pageTitle: this.getPageTitle(),
      id: 0,
      tableId: "short_listed_candidates",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: SHORT_LIST_CANDIDATES,
        showHeader: true,
        columns: [
          {
            title: this.$t("Applicant Id"),
            type: "custom-html",
            key: "id",
            sortable: true,
            modifier: (value, row) => {
              const baseId = 10000;
              const applicantId = baseId + value;

              // Optional: Add company prefix or logic
              // e.g., if company_id = 3, you could show A03-10002
              const companyPrefix = row.company_id ? `C${String(row.company_id).padStart(2, '0')}-` : '';

              return `<span>${companyPrefix}${applicantId}</span>`;
            },
          },
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "forename",
            sortable: true,
            modifier: (value) => {
              return `<span>${value??''}</span>`;
            },
          },
          {
            title: this.$t("middle_name"),
            type: "custom-html",
            key: "middle_name",
            sortable: true,
            modifier: (value) => {
              return `<span>${value??''}</span>`;
            },
          },
          {
            title: this.$t("Surname"),
            type: "custom-html",
            key: "surname",
            sortable: true,
            modifier: (value) => {
              return `<span>${value??''}</span>`;
            },
          },
          {
            title: this.$t("Forms Completion"),
            type: "custom-html",
            key: "form_completion_percentage",
            modifier: value =>
                `<span data-toggle="tooltip" title="This has been estimated by the completion of forms.">
                   ${value ? `${value}%` : ""}
                 </span>`
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("add-to-screening"),
            icon: "award",
            type: "none",
          },
          {
            title: this.$t("delete"),
            icon: "delete",
          },
        ],
        filters: [],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      addToScreeningModalShow: false,
      modalId: "add_to_screening_modal",
      screening: {
        created_at: '',
        date: '',
        // time: '',
        user: '',
        screening_type: '',
        availCredit: 0
      },
      availableCredits: 0,
      isCreditsValid: false,
      screeningTypeList: screeningTypeList,
      screeningDuration: screeningDuration,
      applicantAuthorizationEmail: false,

    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  computed: {
    today() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
  },
  methods: {
    mergeDateTime,
    getPageTitle() {
      let pageTitle = 'Shortlisted Candidates';
      let customerCompany = this.customerCompany;
      if (customerCompany) {
        pageTitle = 'Screening For ' + customerCompany.company_name;
      }
      return pageTitle;
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("view")) {
        window.location.replace(`/candidate-detail/${rowData.company_id}/${rowData.id}`);
      } else if (actionObj.title == this.$t("add-to-screening")) {
        this.getCredits();
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteApplication(rowData.company_id, rowData.id)
        // window.open(`/candidate-detail/${rowData.company_id}/${rowData.id}?applicant_archive=${rowData.application_archive?.id}`, '_blank');
      }
    },
    deleteApplication(companyId, applicantId){
      if (confirm('Are you sure to delete this application?')){
        let deleteUrl =`${DELETE_APPLICATION}/${companyId}/${applicantId}`;
        this.axiosDelete(deleteUrl)
            .then((response) => {
              this.$toastr.s(response.data);
            })
            .catch((response) => {
              this.$toastr.e(response.response.data);
              //trigger after error
            })
            .finally(() => {
              this.$hub.$emit("reload-" + this.tableId);
            });
      }

    },
    async getCredits() {
      try {
        const { data } = await Credits.getAvailableCredits();

        const _credits = data?.data?.available_credits ?? 0;
        if (!_credits) {
          this.$toastr.e("You don't have any credits.");
          return;
        }

        this.availableCredits = _credits;
        this.screening.availCredit = _credits;

        // Ask the user BEFORE opening the modal
        try {
          await this.$confirm(
              'Do you want to send the applicant an email summarizing the changes you just made?',
              'Send changes via email?',
              {
                type: 'info',
                confirmButtonText: 'Yes, send email',
                cancelButtonText: 'No, not now',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                distinguishCancelAndClose: true,
              }
          );
          // If user clicked "confirm"
          this.applicantAuthorizationEmail = true;
        } catch (action) {
          // action is 'cancel' or 'close' — treat both as "No"
          this.applicantAuthorizationEmail = false;
        }

        // Now open the modal
        this.addToScreeningModalShow = true;

      } catch (e) {
        this.$toastr.e('Unable to fetch credits.');
        // optional: console.error(e);
      }
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    save() {
      if (!this.isCreditsValid) {
        this.$toastr.e('Credits are not enough, please purchase credits.');
        return;
      }

      // const startDate = this.mergeDateTime(this.screening.date.toString(), this.screening.time.toString());
      // const startDate = this.mergeDateTime(this.screening.date.toString());
      const createdAt = this.getDateFormatForBackend(this.screening.created_at?.toString());
      const startDate = this.getDateFormatForBackend(this.screening.date.toString());
      const DeploymentDate = this.getDateFormatForBackend(this.screening.deployment_date);

      if (!this.screening.created_at) {
        this.$toastr.e(this.$t("Please select screening creation date"));
        return;
      }
      if (moment(startDate).isBefore(moment(createdAt))) {
        this.$toastr.e(this.$t("Screening date cannot be before creation date"));
        return;
      }
      if (moment(DeploymentDate).isBefore(moment(createdAt))) {
        this.$toastr.e(this.$t("Deployment date cannot be before screening creation date"));
        return;
      }

      const body = {
        applicant_id: this.rowData.id,
        created_at: createdAt,
        start_date: startDate,
        deployment_date: DeploymentDate,
        company_id: this.rowData.company_id,
        screening_type: this.screening.screening_type,
        previous_history_duration: this.screening.previous_history_duration,
        user: this.screening.user,
        applicant_authorization_email: this.applicantAuthorizationEmail
      };
      Candidate.postScreeningSchedule(body)
          .then(({data}) => {
            this.$toastr.s(data.message);
            this.closeModal();
            this.$hub.$emit('reload-' + this.tableId);
          }).catch((error) => {
            const message =
                error.response?.data?.message || error.response?.message || 'Something went wrong';
            this.$toastr.e(message);
          });
    },
    openLink() {
      window.location = '/screening-credits';
    },
    screeningTypeOnChange() {
      this.screening.availCredit = this.availableCredits;
      if (this.screening.screening_type === screeningType.Internal) {
        this.screening.availCredit -= screeningCreditsByType.internal;
      } else {
        this.screening.availCredit -= screeningCreditsByType.admin;
      }
      if (this.screening.availCredit < 0) {
        this.screening.availCredit = this.availableCredits;
        this.isCreditsValid = false;
        this.$toastr.e('There are not Enough Credits, for selected Screening Type.');
        return;
      }
      this.isCreditsValid = true;
    },
    closeModal() {
      this.addToScreeningModalShow = false;
      $(`#${this.modalId}`).modal('hide');
    },
  }
};
</script>

<style scoped>
::v-deep .modal-body,
::v-deep .modal-content {
  overflow: visible !important;
}
</style>
